import { userForgotPassword } from "../../../helpers/backend_helper";
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  loadingData,
} from "./reducer";

export const forgotPassword = (payload) => async (dispatch) => {
  try {
    dispatch(loadingData(true));
    const response = await userForgotPassword(payload);

    const data = response;

    dispatch(userForgetPasswordSuccess(data));
    return data;
  } catch (error) {
    console.log("error", error);
    
    const errorMessage = error?.response?.data?.errors;
    dispatch(userForgetPasswordError(errorMessage));
  } finally {
    dispatch(loadingData(false));
  }
};
